
function getTtl(e,t){var i=parseInt($("input:radio.bkyfl:checked").data("price"));total=i+e+t,saved=e+t==0?0:.05*total,discounted=total-saved,$("#berkyttl").val(theme.Currency.formatMoney(discounted,theme.moneyFormat)),0==saved?$("#savdtotal").html(""):$("#savdtotal").html("You save "+theme.Currency.formatMoney(saved,theme.moneyFormat)+" from your Bundled Package!")}
function initBerkey(){var e=0,t=0;$("#berkyttl").val(theme.Currency.formatMoney(parseInt($("input:radio.bkyfl:checked").data("price"))+e,theme.moneyFormat)),$(".labeladdon").click(function(i){i.stopImmediatePropagation(),i.preventDefault(),input_item=$(this).find("input:checkbox"),$(input_item).prop("checked",!$(input_item).prop("checked")),$(input_item).is(":checked")?(getTtl(e+=parseInt($(input_item).data("price")),t),$(input_item).parents(".variantSelectItem").addClass("berkeyselected")):(getTtl(e-=parseInt($(input_item).data("price")),t),$(input_item).parents(".variantSelectItem").removeClass("berkeyselected"))}),$(".labelbkyfl").click(function(i){i.stopImmediatePropagation(),i.preventDefault(),input_item=$(this).find("input:radio"),$(input_item).prop("checked",!$(input_item).prop("checked")),$(input_item).is(":checked")&&(getTtl(e,t),$(input_item).parent().addClass("berkeyselected"),$(input_item).parent().siblings().removeClass("berkeyselected"),$(".variant-sku").html("ITEM "+$(this).data("sku")))}),$(".labelfluofl").click(function(i){i.stopImmediatePropagation(),i.preventDefault(),input_item=$(this).find("input:checkbox"),$(this).hasClass("berkeyselected")?(getTtl(e,t=0),$(input_item).prop("checked",!1),$(input_item).parent().siblings().find("input:checkbox.fluofl").prop("checked",!1),$(input_item).parents(".variantSelectItem").removeClass("berkeyselected"),$(input_item).parent().siblings().removeClass("berkeyselected")):(t=parseInt($(input_item).data("price")),getTtl(e,t),$(input_item).prop("checked",!0),$(input_item).parent().siblings().find("input:checkbox.fluofl").prop("checked",!1),$(input_item).parent().addClass("berkeyselected"),$(input_item).parent().siblings().removeClass("berkeyselected"))})}

function getBlemTtl(e,t){var i=parseInt($("input:radio.bkyfl:checked").data("price"));total=i+e+t,saved=0,discounted=total-saved,$("#berkyttl").val(theme.Currency.formatMoney(discounted,theme.moneyFormat)),$("#savdtotal").html("")}
function initBlemBerkey(e,t){e=0,t=0;$("#berkyttl").val(theme.Currency.formatMoney(parseInt($("input:radio.bkyfl:checked").data("price"))+e,theme.moneyFormat)),$(".labeladdon").click(function(i){i.stopImmediatePropagation(),i.preventDefault(),input_item=$(this).find("input:checkbox"),$(input_item).prop("checked",!$(input_item).prop("checked")),$(input_item).is(":checked")?(getBlemTtl(e+=parseInt($(input_item).data("price")),t),$(input_item).parents(".variantSelectItem").addClass("berkeyselected")):(getBlemTtl(e-=parseInt($(input_item).data("price")),t),$(input_item).parents(".variantSelectItem").removeClass("berkeyselected"))}),$(".labelbkyfl").click(function(i){i.stopImmediatePropagation(),i.preventDefault(),input_item=$(this).find("input:radio"),$(input_item).prop("checked",!$(input_item).prop("checked")),$(input_item).is(":checked")&&(getBlemTtl(e,t),$(input_item).parent().addClass("berkeyselected"),$(input_item).parent().siblings().removeClass("berkeyselected"),$(".variant-sku").html("ITEM "+$(this).data("sku")))}),$(".labelfluofl").click(function(i){i.stopImmediatePropagation(),i.preventDefault(),input_item=$(this).find("input:checkbox"),$(this).hasClass("berkeyselected")?(getBlemTtl(e,t=0),$(input_item).prop("checked",!1),$(input_item).parent().siblings().find("input:checkbox.fluofl").prop("checked",!1),$(input_item).parents(".variantSelectItem").removeClass("berkeyselected"),$(input_item).parent().siblings().removeClass("berkeyselected")):(t=parseInt($(input_item).data("price")),getBlemTtl(e,t),$(input_item).prop("checked",!0),$(input_item).parent().siblings().find("input:checkbox.fluofl").prop("checked",!1),$(input_item).parent().addClass("berkeyselected"),$(input_item).parent().siblings().removeClass("berkeyselected"))})}

function initPTabScrll(){
    if($('.tlisthldr').length > 0){
        $('.tlisthldr .tab').on('click', function (e) {
            if ($(this).hasClass('oke-is-clickable')) {
                $(".oke-is-clickable")[0].click()
                return;
            }
            $(".tlisthldr .tab").removeClass("has-active");
            $(this).addClass("has-active");

            // Get the target element
            const targetId = $(this).data('target');
            const targetElement = $('#' + targetId);

            //shopify-block-AMkNVL01kUUJ2bjQ0U__okendo_reviews_widget_TEnrWi

            //shopify-block-okendo_reviews_widget_TEnrWi
            //shopify-block-okendo_reviews_widget_tenrwi

            // Check if the target element exists
            if (targetElement.length) {
                $("html, body").animate(
                    { scrollTop: targetElement.offset().top - 220 },
                    300
                );
            } else {
                console.error(`Element with ID '${targetId}' not found.`);
            }
        });

    }

}

if($('.tabttlname').length > 0){
    $('.tabttlname').on('click',function(e){
        //console.log('bbbbbbb')
        var trgt = $(this).data('target');

        $(this).next("#"+trgt).toggle()

        $(this).toggleClass('active')
    });


    const mql = window.matchMedia('(max-width: 767px)');

    window.onload = function () {

        console.log('on loaded')
        if (mql.matches) {

            $( '.overview, .reviews-n-questions, .tabttlname.description, .tabcnm.description' ).addClass("active")
        }
    }
}

function initKitsTemp(){
    $(".peerkits .pele.available").on("click",function(t){
        $(this).siblings().removeClass("selected"),
            $(this).siblings().find("label").removeClass("selected"),
            $(this).addClass("selected"),
            $(this).find("label").addClass("selected");

        var curr = $('.kitppl label.selected').data('ppl');
        var dd = document.getElementById('kitllist');
        for (var i = 0; i < dd.options.length; i++) {
            if (dd.options[i].text === curr) {
                dd.selectedIndex = i;
                break;
            }
        }
        $('.h2.product-single__title').html($('.kitppl label.selected').data('ttl'));
        $('.currtitle').html($('.kitppl label.selected').data('ttl'));
        $('.product-single__sku span').html($('.kitppl label.selected').data('sku'));
        $('.product__price').html($('.kitppl label.selected').data('price'));
        $('.product__price--compare').html($('.kitppl label.selected').data('sale-price'));

        $('.featurebullets').addClass('hide');
        $('.featurebullets.'+curr).removeClass('hide');


        loadProductContent(curr);

    });
}
function initMylarTemp(){
    $(".peermylars .peerselll .swatch-element").on("click",function(t){



        $(this).siblings().removeClass("selected"),
            $(this).siblings().find("label").removeClass("selected"),
            $(this).addClass("selected"),
            $(this).find("label").addClass("selected");

        if($(this).hasClass('available')){$('.stockstatus').attr('class','stockstatus instock');$('button.add-to-cart').attr('disabled',false);}
        else {$('.stockstatus').attr('class','stockstatus outofstock');$('button.add-to-cart').attr('disabled',true);}

        $('.peermylars .varholder').addClass('hide');
        $('.'+$(this).data('vardv')).removeClass('hide');

        var curr = $(this).data('sfvid');
        document.getElementById('mylrllist').value = curr;

        $('.h2.product-single__title').html($(this).data('ttl'));
        $('.product-single__sku span').html($(this).data('sku'));
        $('.currtitle').html($(this).data('ttl'));

        loadProductContent($(this).data('url'));

        //processQbrktag("",$(this).data('sku'));
    });
}
function initColorsTemp(){
    $(".peercolors .peerselll .swatch-element").on("click",function(t){


        $(this).siblings().removeClass("selected"),
            $(this).siblings().find("label").removeClass("selected"),
            $(this).addClass("selected"),
            $(this).find("label").addClass("selected");

        if($(this).hasClass('available')){$('.stockstatus').attr('class','stockstatus instock');$('button.add-to-cart').attr('disabled',false);}
        else {$('.stockstatus').attr('class','stockstatus outofstock');$('button.add-to-cart').attr('disabled',true);}

        $('.peermylars .varholder').addClass('hide');
        $('.'+$(this).data('vardv')).removeClass('hide');

        var curr = $(this).data('sfvid');
        document.getElementById('clrlist').value = curr;

        $('.h2.product-single__title').html($(this).data('ttl'));
        $('.currtitle').html($(this).data('ttl'));
        $('.product-single__sku span').html($(this).data('sku'));
        loadProductContent($(this).data('url'));
        //processQbrktag("",$(this).data('sku'));
    });

}


function initCustomProdScr(){
    if(document.getElementById('pfberkey') != null){initBerkey();}
    if(document.getElementById('pfblemberkey') != null){initBlemBerkey();}
    if(document.getElementById('mylrllist') != null){initMylarTemp()}
    if(document.getElementById('clrlist') != null){initColorsTemp()}
    if(document.getElementById('kitllist') != null){initKitsTemp()}
    window.onload = function () {
        initPTabScrll();
    }
}
initCustomProdScr()
function initCustomCollScr(){
    const lmorediv = document.querySelector(".collloadmore");
    const cprodiv = document.querySelector(".collprodcontainer");
    if(lmorediv != null || lmorediv != undefined){
        var pagecount = parseInt(lmorediv.dataset.pgcnt);
        var fetch_index = 1;
        $(window).scroll(function() {
            if($(window).scrollTop() > $('.collloadmore').position().top - 1000) {
                // console.log(fetch_index);
                if(fetch_index != -1){
                    if(fetch_index != parseInt(lmorediv.dataset.nxt)){
                        fetch_index = fetch_index + 1;
                        var addr = lmorediv.dataset.url+'?view=paginax&page='+parseInt(lmorediv.dataset.nxt);
                        fetch(addr, { credentials: 'same-origin' })
                            .then(function(response) {
                                return response.text();
                            })
                            .then(function(text) {
                                const parser = new DOMParser();
                                const htmlDocument = parser.parseFromString(text, "text/html");
                                var pagehtml = htmlDocument;
                                cprodiv.innerHTML += pagehtml.body.innerHTML;
                                if(fetch_index < pagecount)
                                {lmorediv.dataset.nxt = parseInt(lmorediv.dataset.nxt) + 1;}
                                else {lmorediv.classList.add('hide');fetch_index = -1;}
                                //StampedFn.reloadUGC();
                            })
                            .catch(function(error) {
                                console.log(error);
                            });
                    }
                }
            }
        });

        // lmorediv.addEventListener('click', function(e){
        //   // console.log('l more' + lmorediv.dataset.nxt);
        //   prevpg = parseInt(lmorediv.dataset.nxt);
        //   var addr = lmorediv.dataset.url+'?view=paginax&page='+lmorediv.dataset.nxt;
        //   fetch(addr, { credentials: 'same-origin' })
        //   .then(function(response) {
        //     return response.text();
        //   })
        //   .then(function(text) {
        //       const parser = new DOMParser();
        //       const htmlDocument = parser.parseFromString(text, "text/html");
        //       var pagehtml = htmlDocument;
        //       cprodiv.innerHTML += pagehtml.body.innerHTML;
        //       if(parseInt(lmorediv.dataset.nxt) < pagecount)
        //       {lmorediv.dataset.nxt = parseInt(lmorediv.dataset.nxt) + 1;}
        //       else {lmorediv.classList.add('hide');}
        //       StampedFn.reloadUGC();
        //   })
        //   .catch(function(error) {
        //     console.log(error);
        //   });
        // });
    }
}

theme.Collection = (function () {
    $(".collapsible-trigger-btn").click( function (e) {
        e.preventDefault();
        $(this).toggleClass("has-active");
        $( this ).next(".collapsible-content").slideToggle("fast");
    });
})

function updateCartExtras(cart_subttl){

    if (cart_subttl > 9999) {
        document.getElementById('cartshipping').innerHTML = '<div class="cartfreeshipping availablefreeshipping">You\'re Eligible For Free Shipping!</div>';
    } else {
        $freeshippingbalance = 9999 - cart_subttl;
        document.getElementById('cartshipping').innerHTML = '<div class="cartfreeshipping addmore">You\'re only ' + theme.Currency.formatMoney($freeshippingbalance, theme.moneyFormat) + ' away from free shipping!</div>';
    }
}

function initScrollArrow(){
    $(".scrollup").hide(),$(window).scroll(function(){$(this).scrollTop()>170?$(".scrollup").fadeIn():$(".scrollup").fadeOut()}),$(".scrollup").click(function(){return $("body,html").animate({scrollTop:0},800),!1});
}
/*
function isMobile(){
    return !(window.getComputedStyle(document.getElementById('isMobile')).display === "none")
}
function initFooterAcc(){
    if(isMobile()){
        document.querySelectorAll('.footer__title').forEach(function(b){
            b.addEventListener('click', function(evt){
                if(b.nextElementSibling.style.display != 'block')
                {b.nextElementSibling.style.display = 'block';b.classList.add('open');}
                else
                {b.nextElementSibling.style.display = 'none';b.classList.remove('open');}
            });
        });
    }
}
 */
function initCartScript(){
    $('.rmvlink').on('click',function(e){
        document.dispatchEvent(new CustomEvent('cart:quantity' + '.product', {detail: [$(this).data('key'), 1]}));
        // document.dispatchEvent(new CustomEvent('cart:quantity' + '.product', {detail: ['39385184895072:8e039c9eb60f363d9713d3f65375b655', 1]}));
    });
}

function initCommonScr(){
    initScrollArrow();
    //initFooterAcc();
    //initCartScript();
    // $( document ).ajaxComplete(function( event, xhr, settings ) {StampedFn.reloadUGC();});


    $('#paybright-learnmore').on('click', function(e){
        $('#pbModal').show();
    });

    $('.paybright-class-close').on('click', function(e){
        $('.paybright-class-modal').hide();
    });
}

function removeAffirmMessaging(root){
    var scope = root && root.querySelectorAll ? root : document;
    var affirmSelectors = '.affirm-as-low-as, .affirm-modal-trigger, [class*="__affirm-logo"], [data-affirm-modal], [data-pb-modal], #paybright-widget-container, .paybright-widget-container, #pbModal, .paybright-class-modal, .earn__point-title';
    var exactAffirmPatterns = [
        /^buy now, pay later with affirm$/i,
        /^pay with affirm on orders over \$50(?:\.00)?\. learn more$/i,
        /^pay with affirm on orders over \$50(?:\.00)? learn more$/i,
        /^finance with affirm$/i
    ];

    scope.querySelectorAll(affirmSelectors).forEach(function(node){
        node.remove();
    });

    scope.querySelectorAll('label, a, li, p, span, small, strong').forEach(function(node){
        var normalizedText = (node.textContent || '').replace(/\s+/g, ' ').trim();

        if (!normalizedText || normalizedText.length > 80) {
            return;
        }

        if (exactAffirmPatterns.some(function(pattern){ return pattern.test(normalizedText); })) {
            node.remove();
        }
    });
}

function initAffirmCleanup(){
    removeAffirmMessaging(document);

    var observer = new MutationObserver(function(mutations){
        mutations.forEach(function(mutation){
            mutation.addedNodes.forEach(function(node){
                if (node.nodeType !== 1) {
                    return;
                }

                if (node.matches && node.matches('.affirm-as-low-as, .affirm-modal-trigger, [class*="__affirm-logo"], [data-affirm-modal], [data-pb-modal], #paybright-widget-container, .paybright-widget-container, #pbModal, .paybright-class-modal, .earn__point-title')) {
                    node.remove();
                    return;
                }

                removeAffirmMessaging(node);
            });
        });
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
}


document.addEventListener('DOMContentLoaded', function() {
    initAffirmCleanup();
    //initCommonScr();
});

function initCustomPageScr(){
    initPageAccordion();
}

function initPageAccordion(){
    /*
    if($(".faqaccordion").length>0){$(".faqaccordion h3").on("click",function(i){
      if($(this).next('.accans').is(":visible"))
      {$(this).next('.accans').slideUp(),$(this).removeClass("active")}
      else {$(this).next('.accans').slideDown(),$(this).addClass("active")}
    })}

     */

}


function loadProductContent(url){
    fetch('/products/'+url+'/?view=content', { credentials: 'same-origin' })
        .then(function(response) {
            return response.text();
        })
        .then(function(text) {
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(text, "text/html");
            const html = htmlDocument.documentElement.querySelector('#shopify-section-product-sections-template');
            document.getElementById('shopify-section-product-sections-template').innerHTML = html.innerHTML;

            $('.hero__image-wrapper').css('transform','none');
            $('.hero__image-wrapper').css('opacity','1');
            initPTabScrll();
            loadProductWindowUrl(url);
            //StampedFn.reloadUGC();
        })
        .catch(function(error) {
            console.log(error);
        });
}
function loadProductWindowUrl(url){
    arr = window.location.pathname.split('/');
    arr.pop();
    arr.push(url);
    var newurl = window.location.protocol + '//' + window.location.host + arr.join('/');
    window.history.replaceState({path: newurl}, '', newurl);
    window.location.href = newurl;
}
function loadProductForm(url){

    //   request = new XMLHttpRequest();

    //   request.open('GET', '/products/4-person-72hrs-deluxe-backpack-emergency-survival-kit/?sections=product-template', true);

    //   request.send();
    // console.log(request.responseText);
    //   html = JSON.parse(request.responseText);
    //   document.getElementById('databasket').innerHTML = html;

    fetch('/products/'+url+'/?view=form', { credentials: 'same-origin' })
        .then(function(response) {
            return response.text();
        })
        .then(function(text) {
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(text, "text/html");
            const html = htmlDocument.documentElement.querySelector('#shopify-section-product-template');
            document.getElementById('shopify-section-product-template').innerHTML = html.innerHTML;
            console.log('ssdd');
        })
        .catch(function(error) {
            console.log(error);
        });
}

$(document).ready( function(){
    $(".faqaccordion h3").click( function(){
        if(!$(this).hasClass("active")){
            $(this).addClass("active");
        }else if ($(this).hasClass("active")) {
            $(this).removeClass("active");
        }
        $(this).next("div").slideToggle();
    });

    /* show more filter ( collection page ) */

    $(".show-more-filter-js").click( function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active')
        $(this).closest('.collapsible-content__inner').toggleClass('is-active')
    });

});
jQuery(document).ready(function($){
  //if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
  var $L = 1200,
      $menu_navigation = $('#main-nav'),
      $hamburger_icon = $('#cd-hamburger-menu'),
      $cart_trigger = $('.collection-filter__btn'),
      $lateral_cart = $('#CollectionSidebar'),
      $shadow_layer = $('#cd-shadow-layer'),
      $closs_pop = $('.close-pop');
  //open lateral menu on mobile
  $hamburger_icon.on('click', function(event){
    event.preventDefault();
    //close cart panel (if it's open)
    $lateral_cart.removeClass('speed-in');
    toggle_panel_visibility($menu_navigation, $shadow_layer, $('body'));
  });
  //open cart
  $(document).on('click','.collection-filter__btn', function(event){
//  $cart_trigger.on('click', function(event){
    //event.preventDefault();
    //close lateral menu (if it's open)
    //toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
    // $('.collection-filter__btn').removeClass('is-active');

  });

  // collection page hero banner button click then go to product section
  $(".go-to-product-grid-js").click( function (e) {
      e.preventDefault();

      $('html, body').animate({
          scrollTop: $("#CollectionAjaxContent,#gullfoss_main_grid_container").offset().top
      }, 100);
  })

  //close lateral cart or lateral menu
  $shadow_layer.on('click', function(){
    $shadow_layer.removeClass('is-visible');
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    if( $lateral_cart.hasClass('speed-in') ) {
      $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        $('body').removeClass('overflow-hidden');
      });
    } else {
      $lateral_cart.removeClass('speed-in');
    }
  });
  //close lateral cart or lateral menu
  $closs_pop.on('click', function(){
    $shadow_layer.removeClass('is-visible');
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    if( $lateral_cart.hasClass('speed-in') ) {
      $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        $('body').removeClass('overflow-hidden');
      });
    } else {
      $lateral_cart.removeClass('speed-in');
    }
    $('.collection-filter__btn').removeClass('is-active');
  });
});

function toggle_panel_visibility ($lateral_panel, $background_layer, $body) {
  if( $lateral_panel.hasClass('speed-in') ) {
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    $lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
      $body.removeClass('overflow-hidden');
    });
    $background_layer.removeClass('is-visible');

  } else {
    $lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
      $body.addClass('overflow-hidden');
    });
    $background_layer.addClass('is-visible');
  }
}

// product page tab with slider
class videoTextColumns extends HTMLElement{
    constructor() {
        super();

        this.sliderID = this.querySelector('[id^="video-text-columns--"]')
        if (!this.sliderID) return;
        this.perView = parseInt(this.getAttribute('data-slide'));

        console.log(this.perView)

        const swiperTab = new Swiper(this.sliderID, {
            slidesPerView: 1,
            
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                768: {
                    slidesPerView: this.perView,
                    
                },
                1024: {
                    slidesPerView: this.perView
                },
            },
        });
    }
}
customElements.define('video-text-columns', videoTextColumns)

if (!customElements.get('brand-category-slider')) {
  customElements.define('brand-category-slider', class BrandCategorySlider extends HTMLElement {
    connectedCallback() {
      if (this.swiperInstance) return;

      this.swiperEl = this.querySelector('.collection-by-brand-category-slider__swiper');
      this.prevEl = this.querySelector('[data-brand-slider-prev]');
      this.nextEl = this.querySelector('[data-brand-slider-next]');

      if (!this.swiperEl || !this.prevEl || !this.nextEl) return;

      this.initSwiper();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') {
        window.setTimeout(() => this.initSwiper(), 100);
        return;
      }

      this.swiperInstance = new Swiper(this.swiperEl, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: this.prevEl,
          nextEl: this.nextEl
        },
        breakpoints: {
          0: {
            spaceBetween: 16
          },
          769: {
            spaceBetween: 20
          }
        }
      });
    }
  });
}

/* PPE mobile filter popup: "View All Items" closes drawer (match food UX) */
(function initPpeMobileFilterApply() {
  if (document.documentElement.dataset.ppeFilterApplyBound === '1') return;
  document.documentElement.dataset.ppeFilterApplyBound = '1';

  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('template-collection-ppe')) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;

    var applyBtn = event.target.closest('.filter-popup-content .gullfoss-reset-filter-button');
    if (!applyBtn) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var closeBtn = document.querySelector('#filter_popup_container .filter-popup-close, .filter-popup-close');
    if (closeBtn) {
      closeBtn.click();
      return;
    }

    var overlay = document.querySelector('#filter_overlay');
    var container = document.querySelector('#filter_popup_container');
    if (container) {
      container.style.display = 'none';
      container.style.opacity = '0';
      container.classList.remove('active', 'is-active', 'open');
    }
    if (overlay) {
      overlay.style.display = 'none';
      overlay.style.opacity = '0';
    }
  }, true);
})();
